<ng-container *transloco="let t; read: 'partials.agenda.blocks.conference'">
  <div *ngIf="container" class="agenda-block">
    <app-agenda-exercise-headline
      [container]="container"
      [type]="'conference'"
      [title]="t('conference')"
    ></app-agenda-exercise-headline>
  </div>
</ng-container>
